import DashboardContainer from "@legacy/dashboard/DashboardContainer"

import { faIcon } from "@utils/faIcon"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

export default function Dashboard() {
    return (
        <AppFrame.Root>
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageTitle label="Home" icon={faIcon({ name: "house", style: "solid" })} />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <DashboardContainer />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
